export const API_URL = process.env.APP_API_URL || "https://api.vrallart.com"
export const CONTENT_URL =
  process.env.APP_CONTENT_URL || "https://content.vrallart.com/"
